import React from "react"
import { FormattedMessage } from "react-intl"
import { Button, DialogTitle } from "@carrotfertility/carotene-core"
import { DialogActionsBar } from "@carrotfertility/carotene-core-x"
import { useReimbursementContext } from "#/components/context/reimbursement/GetReimbursedContext"
import { ReimbursementDialogFraming } from "../shared/layouts"

// Temporary stand-in for submission (FBEP-863). Uses only existing strings so it adds nothing to translate.
export const CbpdPlaceholder = (): JSX.Element => {
  const { onExit } = useReimbursementContext()
  return (
    <>
      <ReimbursementDialogFraming>
        <DialogTitle>
          <FormattedMessage defaultMessage="Coming soon!" />
        </DialogTitle>
      </ReimbursementDialogFraming>
      <DialogActionsBar
        primaryAction={
          <Button color="primary" onClick={onExit}>
            <FormattedMessage defaultMessage="Close" />
          </Button>
        }
      />
    </>
  )
}
